import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";

const CONTACT_ITEMS = [
  {
    icon: MapPin,
    title: "Address",
    value: "Ongur, Tindivanam Taluk, Villupuram District,Tamil Nadu – 604 305",
    action: {
      label: "Find Location",
      href: "https://www.google.com/maps/search/?api=1&query=Takshashila+Medical+College+Ongur+Tamil+Nadu",
      external: true,
    },
  },
  {
    icon: Mail,
    title: "Email Address",
    value: "deantmch@takshashilauniv.ac.in",
    action: {
      label: "Get In Touch",
      href: "mailto:deantmch@takshashilauniv.ac.in",
    },
  },
  {
    icon: Phone,
    title: "Phone Number",
    value: "+91 8925969546",
    action: {
      label: "Contact Us Today!",
      href: "tel:+918925969546",
    },
  },
];

const ContactInner = () => {
  return (
    <section className="univ-contact">
      <div className="univ-wrap">
        <div className="univ-contact-heading">
          <p className="univ-eyebrow">GET IN TOUCH</p>
          <h2>Let us help you</h2>
          <p className="univ-contact-lead">
            Our platform is built on the principles of innovation, quality, and
            inclusivity, aiming to provide a seamless learning
          </p>
        </div>
        <div className="univ-contact-grid">
          {CONTACT_ITEMS.map(({ icon: Icon, title, value, action }) => (
            <article className="univ-contact-card" key={title}>
              <span className="univ-contact-icon" aria-hidden="true">
                <Icon size={20} />
              </span>
              <h3>{title}</h3>
              <p>{value}</p>
              <a
                className="univ-contact-action"
                href={action.href}
                {...(action.external
                  ? { target: "_blank", rel: "noreferrer" }
                  : {})}
              >
                {action.label} <ArrowUpRight size={16} />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInner;
